import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {DetailedDescriptionItem} from 'modules/product-card/components/DetailedDescriptionItem';
// import {DetailedDescriptionItemImages} from 'modules/product-card/components/DetailedDescriptionItem/DetailedDescriptionItemImages';
import {getProductDescriptionsList} from 'modules/product-card/helpers/description';
import {selectProductData} from 'modules/product-card/selectors';
import {FC, useMemo} from 'react';
import style from './style.module.scss';
import {DetailedDescriptionItemImages} from 'modules/product-card/components/DetailedDescriptionItem/DetailedDescriptionItemImages';
import {IFoodItem} from 'modules/product-card/types';
import {isProductFineAndRare} from 'modules/product-card/helpers';

export const DetailedDescriptionList: FC = () => {
    const productData = useAppSelector(selectProductData);
    const isFineAndRareCategory = isProductFineAndRare(productData);

    const descriptionsList = useMemo(() => {
        if (!productData) {
            return [];
        }

        return getProductDescriptionsList(productData);
    }, [productData]);

    const food = productData?.properties?.find((item) => 'food' === item.code);
    // eslint-disable-next-line no-shadow
    const imageList = ((food?.value || []) as IFoodItem[]).filter((food) => Boolean(food.imagePath));

    return (
        <div className={style.main}>
            {descriptionsList.map(({isHTML, title, value, code}) => {
                if ('gastronomy' === code) {
                    if (isFineAndRareCategory) {
                        return null;
                    }

                    return (
                        <DetailedDescriptionItemImages key={code} imageList={imageList} title={title} value={value} />
                    );
                }

                return <DetailedDescriptionItem key={title} isHTML={isHTML} title={title} value={value} />;
            })}
        </div>
    );
};
